import Refund from "../../../shared/components/icons/Refund";

export default Refund;
